/**
 * 当前已打开弹窗的名称集合，例如 ['menu'] 或 ['letter']。
 * 使用数组而非单值，是为了让通用 LitPopup 包装器支持多个弹窗实例。
 */
import { atom, useRecoilState } from 'recoil';

const openedPopupsState = atom<string[]>({
    key: 'openedPopupsState',
    default: [],
});

export const useOpenedPopupsState = () => useRecoilState(openedPopupsState);
